/**
 * Configuration centralisée des langues disponibles dans l'application
 */

export const LANGUAGE_CODES = {
  ENGLISH: 'en',
  ENGLISH_US: 'us',
  SPANISH: 'es',
  FRENCH: 'fr',
  NETHERLANDS: 'nl',
  GERMAN: 'ge',
  DUTCH: 'du',
  HUNGARIAN: 'hu',
  PORTUGAL: 'pt',
  SHOWROOM: 'showroom',
}

export const LANGUAGE_LABELS = {
  [LANGUAGE_CODES.ENGLISH]: 'Anglais',
  [LANGUAGE_CODES.ENGLISH_US]: 'Anglais - US',
  [LANGUAGE_CODES.SPANISH]: 'Espagnol',
  [LANGUAGE_CODES.FRENCH]: 'Français',
  [LANGUAGE_CODES.NETHERLANDS]: 'Néerlandais',
  [LANGUAGE_CODES.DUTCH]: 'Dutch',
  [LANGUAGE_CODES.GERMAN]: 'Allemand',
  [LANGUAGE_CODES.HUNGARIAN]: 'Hongrois',
  [LANGUAGE_CODES.PORTUGAL]: 'Portugais',
  [LANGUAGE_CODES.SHOWROOM]: 'Showroom',
}

export const LANGUAGE_LABELS_ENGLISH = {
  [LANGUAGE_CODES.ENGLISH]: 'English',
  [LANGUAGE_CODES.ENGLISH_US]: 'English - US',
  [LANGUAGE_CODES.SPANISH]: 'Spanish',
  [LANGUAGE_CODES.FRENCH]: 'French',
  [LANGUAGE_CODES.NETHERLANDS]: 'Netherlands',
  [LANGUAGE_CODES.DUTCH]: 'Dutch',
  [LANGUAGE_CODES.GERMAN]: 'German',
  [LANGUAGE_CODES.HUNGARIAN]: 'Hungarian',
  [LANGUAGE_CODES.PORTUGAL]: 'Portuguese',
  [LANGUAGE_CODES.SHOWROOM]: 'Showroom',
}

/**
 * Options pour les sélecteurs (sans option vide)
 */
export const getLanguageSelectOptions = (language = LANGUAGE_CODES.FRENCH) => {
  if (language === LANGUAGE_CODES.ENGLISH) {
    return LANGUAGE_LABELS_ENGLISH
  }
  return LANGUAGE_LABELS
}
